import { productQuantityOrderedStyles } from "@insite/content-library/Components/ProductQuantityOrdered";
import { css } from "styled-components";

Object.assign(productQuantityOrderedStyles, {
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        `,
        inputSelect: css`
            -moz-appearance: textfield;
            padding: 0 9px;
            text-align: center;
        `,
    },
});
